export default "__VITE_ASSET__C15GO2_d__"